import * as React from 'react';
import type {ReferralFormParam} from 'src/types/referral-external';
import CandidateFormContainer from 'src/components/referral-external/candidate-form/form-containter';
import {Success} from './refer-success';
import {WithDrawSuccess, TokenInvalid} from './refer-withdraw-success';
import {TrackReferrals} from './track-referral';


export const ReferralExternalWrapper = ({
  params,
}: {
  params: ReferralFormParam;
}) => {
  let Component = () => null;
  if (params.referralLinkId) {
    if (params.action === 'success') {
      // @ts-expect-error - TS2322 - Type '(params: ReferralFormParam) => React.JSX.Element' is not assignable to type '() => null'.
      Component = Success;
    } else if (params.action === 'withdraw-success') {
      // @ts-expect-error - TS2322 - Type '(params: { referralLinkId: string; }) => React.JSX.Element' is not assignable to type '() => null'.
      Component = WithDrawSuccess;
    } else if (params.action === 'token-invalid') {
      // @ts-expect-error - TS2322 - Type '(params: { referralLinkId: string; }) => React.JSX.Element' is not assignable to type '() => null'.
      Component = TokenInvalid;
    } else if (params.action === 'track') {
      // @ts-expect-error - TS2322 - Type '(params: ReferralFormParam) => React.JSX.Element' is not assignable to type '() => null'.
      Component = TrackReferrals;
    } else {
      // @ts-expect-error - TS2322 - Type '({ referralLinkId, token, uid, utm_source, utm_medium, }: ReferralFormParam) => React.JSX.Element' is not assignable to type '() => null'.
      Component = CandidateFormContainer;
    }
  }
  // @ts-expect-error - TS2559 - Type '{ action: string | null | undefined; sourceEmail: string | null | undefined; referralLinkId: string; token: string | null | undefined; uid: string | null | undefined; utm_source: string | ... 1 more ... | undefined; utm_medium: string | ... 1 more ... | undefined; iframe: boolean; }' has no properties in common with type 'IntrinsicAttributes'.
  return <Component {...params} />;
};
